import { type RefObject, useRef } from 'react'
import { useEventListener, useOnClickOutside, useScrollLock } from 'usehooks-ts'

interface UseModal {
  ref: RefObject<HTMLDivElement>
}

interface UseModalProps {
  autoLock?: boolean
  close: () => void
}

export const useModal = ({
  autoLock = true,
  close,
}: UseModalProps): UseModal => {
  const ref = useRef<HTMLDivElement>(null)

  useScrollLock({
    autoLock,
  })

  useOnClickOutside(ref, () => {
    close()
  })

  const escListener = (e: KeyboardEvent) => {
    if (e.code !== 'Escape') {
      return
    }

    close()
  }

  useEventListener('keydown', escListener)

  return { ref }
}
